import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { ApprovalSchemeTypeEnum } from '@zaoblako/shared/modules/catalog/enums/approval-scheme-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link ApprovalSchemeTypeEnum} enumeration values */
export const ApprovalSchemeTypeEnumI18n: EnumI18nInterface<ApprovalSchemeTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [ApprovalSchemeTypeEnum.SEQUENTIAL]: 'Последовательный',
    [ApprovalSchemeTypeEnum.PARALLEL]: 'Параллельный',
  },
  [I18nLocalesEnum.EN_US]: {
    [ApprovalSchemeTypeEnum.SEQUENTIAL]: 'Sequential',
    [ApprovalSchemeTypeEnum.PARALLEL]: 'Parallel',
  },
};
